import { useEffect, useState } from 'react';
import { SearchByInputType } from 'src/graphql';
import {
  DefaultSearchOptionsType,
  SearchValueProps,
} from '../table/useTableColumns';
import { useLocation, useHistory } from 'react-router-dom';
import {
  CaseSearchOptionValues,
  CaseSearchableFields,
  mapParamsToDefaultSearchOptions,
  mapOptionsToParamKeys,
} from 'src/components/pages/Cases/helpers/searchTableHelper';

export const useCaseSearchQueryParams = (queryParams: URLSearchParams) => {
  const [caseQueryParamFields, setCaseQueryParamFields] = useState<
    SearchByInputType[] | null
  >(null);
  const [paramSearchValues, setParamSearchValues] = useState<
    DefaultSearchOptionsType[] | null
  >(null);
  const [paramKey, setParamKey] = useState<string | null>(null);

  const location = useLocation();
  const history = useHistory();

  const searchOptions = Object.values(CaseSearchableFields);

  const foundOption = searchOptions.find((param) => queryParams.has(param));
  const getParamValue = queryParams.get(foundOption ?? '');

  useEffect(() => {
    if (foundOption && getParamValue) {
      const paramOption = mapParamsToDefaultSearchOptions[foundOption];
      const paramValue = getParamValue.replaceAll('"', '');

      setCaseQueryParamFields([
        { fieldName: paramOption.value, fieldValue: paramValue },
      ]);

      setParamSearchValues([
        paramOption,
        { value: paramValue, label: paramValue },
      ]);
    }
  }, [foundOption, getParamValue]);

  const updateUrlParams = (option: SearchValueProps) => {
    const queryParams = new URLSearchParams(location.search);
    if (option.length > 0) {
      if (!paramKey) {
        const key = option[0].value;
        setParamKey(key);
      } else {
        const mappedKey =
          mapOptionsToParamKeys[paramKey as CaseSearchOptionValues];
        if (option.length > 1) {
          const queryVal = option[1].value;
          queryParams.set(mappedKey, queryVal);
        } else {
          queryParams.delete(mappedKey);
        }

        history.push({ search: queryParams.toString() });
      }
    } else {
      setParamKey(null);
    }
  };

  return {
    caseQueryParamFields,
    paramSearchValues,
    setCaseQueryParamFields,
    updateUrlParams,
  };
};
